import type { CustomHeaderGroupProps } from "@/ui/molecules/Grid";

import Typography from "@/ui/atoms/Typography";
import { useCallback, useEffect, useState } from "react";
import { Icon, IconBox } from "@proda-ai/ui-kit";
import Box from "@/ui/atoms/Box";

export const testIds = {
    main: "GridHeaderGroupComponent",
    collapseChevron: "GridHeaderGroupComponent-collapseChevron",
    expandChevron: "GridHeaderGroupComponent-expandChevron",
};

export const GridHeaderGroupComponent = (
    props: CustomHeaderGroupProps & {
        textAlign: "center" | "left" | "right";
    },
) => {
    const { displayName, textAlign = "left" } = props;
    const [expandState, setExpandState] = useState("collapsed");

    const expandOrCollapse = () => {
        const currentState = props.columnGroup
            .getProvidedColumnGroup()
            .isExpanded();
        props.setExpanded(!currentState);
    };

    const syncExpandButtons = useCallback(() => {
        setExpandState(
            props.columnGroup.getProvidedColumnGroup().isExpanded()
                ? "expanded"
                : "collapsed",
        );
    }, [props.columnGroup]);

    useEffect(() => {
        props.columnGroup
            .getProvidedColumnGroup()
            .addEventListener("expandedChanged", syncExpandButtons);
        syncExpandButtons();

        return () => {
            props.columnGroup
                .getProvidedColumnGroup()
                .removeEventListener("expandedChanged", syncExpandButtons);
        };
    }, [props.columnGroup, syncExpandButtons]);

    return (
        <Typography
            variant="h4"
            data-testid={testIds.main}
            sx={{
                width: "100%",
                fontWeight: 500,
                textAlign,
                color: "var(--text-color-light)",
                display: "flex",
                justifyContent: "space-between",
            }}
        >
            {displayName}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    cursor: "pointer",
                }}
            >
                <IconBox>
                    <Icon
                        icon={"triangle-exclamation"}
                        size="sm"
                        color={"var(--proda-yellow"}
                    />
                </IconBox>
                <IconBox
                    style={{
                        transform:
                            expandState !== "collapsed"
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                    }}
                    data-testid={
                        expandState !== "collapsed"
                            ? testIds.collapseChevron
                            : testIds.expandChevron
                    }
                    onClick={() => expandOrCollapse()}
                >
                    <Icon icon={"chevron-right"} size="sm" />
                </IconBox>
            </Box>
        </Typography>
    );
};

export default GridHeaderGroupComponent;
